/** Terms & Conditions page content — /terms-and-conditions */

import { pageRoute, appRoute } from "./paths.js";

export const termsPage = {
  documentTitle: "Taldel — Terms & Conditions",
  eyebrow: "Legal",
  title: "Terms & Conditions",
  subtitle:
    "The rules that govern your use of the Taldel website and how we frame commercial engagements.",
  lastUpdated: "August 11, 2026",
  contactEmail: "hello@taldel.com",
  sections: [
    {
      heading: "1. Agreement to these terms",
      body: "By accessing or using the Taldel website, contacting us through our forms, or otherwise engaging with Taldel online, you agree to these Terms & Conditions. If you do not agree, please do not use the site. Separate written agreements govern client services, staffing, and product work; those agreements control if they conflict with these website terms.",
    },
    {
      heading: "2. Who may use the site",
      body: "You may use this site only if you are able to form a binding contract and are not barred from receiving services under applicable law. You agree to provide accurate information when submitting forms and not to misuse the site or attempt to disrupt its operation.",
    },
    {
      heading: "3. Services overview",
      body: "Taldel offers software engineering, product design, AI, app development, cyber security, and staff augmentation capabilities. Descriptions on the website are for general information. Scope, fees, timelines, ownership, and service levels are defined only in a signed statement of work, master services agreement, or similar commercial contract.",
    },
    {
      heading: "4. Accounts and access",
      body: "If registration or login features are made available, you are responsible for keeping credentials confidential and for activity under your account. We may suspend or terminate access that we reasonably believe violates these terms or poses a security risk. Frontend account flows may be illustrative until backend authentication is enabled.",
    },
    {
      heading: "5. Intellectual property",
      body: "The Taldel name, logos, website design, copy, and other site content are owned by Taldel or its licensors and are protected by intellectual property laws. You may not copy, modify, distribute, or create derivative works from site materials without our prior written consent, except for limited personal, non-commercial viewing of the site.",
    },
    {
      heading: "6. Client work product",
      body: "Ownership of custom work product delivered under a client engagement is governed by the applicable commercial agreement. Nothing on this website transfers ownership of your or our intellectual property outside those contracts.",
    },
    {
      heading: "7. Acceptable use",
      body: "You agree not to use the site to transmit unlawful, harmful, or abusive content; to attempt unauthorized access to systems or data; to scrape or harvest data in a way that burdens our infrastructure; or to misrepresent your identity or affiliation when contacting Taldel.",
    },
    {
      heading: "8. Third-party links",
      body: "The site may link to third-party websites or resources. We are not responsible for their content, policies, or practices. Your use of third-party sites is at your own risk and subject to their terms.",
    },
    {
      heading: "9. Disclaimers",
      body: "The website and its content are provided “as is” and “as available” without warranties of any kind, whether express or implied, including merchantability, fitness for a particular purpose, and non-infringement. We do not warrant that the site will be uninterrupted, error-free, or free of harmful components.",
    },
    {
      heading: "10. Limitation of liability",
      body: "To the fullest extent permitted by law, Taldel and its officers, employees, and agents will not be liable for any indirect, incidental, special, consequential, or punitive damages, or for any loss of profits, data, or goodwill, arising from your use of the website. Our aggregate liability related to website use is limited to one hundred U.S. dollars (USD $100) or the minimum amount required by law. These limits do not override liability terms in signed client contracts.",
    },
    {
      heading: "11. Indemnity",
      body: "You agree to indemnify and hold harmless Taldel from claims, damages, and expenses (including reasonable attorneys’ fees) arising from your misuse of the site or your violation of these terms, except to the extent caused by our willful misconduct.",
    },
    {
      heading: "12. Changes",
      body: "We may update these Terms & Conditions periodically. The “Last updated” date reflects the latest revision. Continued use of the site after changes become effective constitutes acceptance of the revised terms.",
    },
    {
      heading: "13. Governing law",
      body: "These terms are governed by the laws applicable to Taldel’s principal place of business, without regard to conflict-of-law principles, unless a signed commercial agreement specifies otherwise. Courts in that jurisdiction will have exclusive venue for disputes arising from website use, subject to mandatory consumer protections where they apply.",
    },
    {
      heading: "14. Contact",
      body: "Questions about these Terms & Conditions can be sent to hello@taldel.com.",
    },
  ],
  related: {
    label: "Also see",
    href: pageRoute("privacy-policy"),
    linkLabel: "Privacy Policy",
  },
  homeHref: appRoute("hero"),
};

export function getTermsPage() {
  return termsPage;
}

export function termsRoute(section = "") {
  return pageRoute("terms-and-conditions", section);
}
